import React from "react";

import RandingStyle30 from "../../randing/RandingStyle30";

function Randing539({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle30
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      videoSrc="https://d1k8m48tkgq306.cloudfront.net/images/539/01.mp4"
      stepImageBasePath="https://d1k8m48tkgq306.cloudfront.net/images/539"
      companyName="본원"
      privacyCompanyName="검단뉴욕치과의원"
      hideFooter={true}
    />
  );
}

export default Randing539;
